import { observable } from 'mobx';
import { MembershipStore } from 'modules/membership';

class ModuleEditorStore {
  @observable id = null;
  @observable name = '';
  @observable classes = [];

  @observable extra = false;

  @observable publicModule = MembershipStore.hasSeason;

  @observable moduleType = null;
  @observable paidModule = false;
  @observable description = '';
  @observable offerPrice = '';
  @observable playerMedia = null;
  @observable mediaVideoUrl = null;

  @observable moduleDisplayType = 'LIST';
  @observable coverImageId = null;
  @observable coverImageUrl = null;

  @observable image = {};
  @observable media = {};

  @observable season = null;
  @observable hotPassCost = null;

  @observable loaded = true;

  snapshot = {};
}

export default new ModuleEditorStore();
